/**
 * By Lucia — Klaviyo client-side list subscription.
 *
 * Wires any <form data-klaviyo-subscribe data-list-id="..."> to Klaviyo's
 * client subscriptions API, the same path OptiMonk and Klaviyo's own forms use,
 * so the list's "Added to List" welcome flow (discount code) fires.
 *
 * company_id is read at runtime from the Klaviyo Onsite script already loaded in
 * the theme — never hardcoded. List opt-in settings (single/double) are honoured
 * by Klaviyo, so behaviour matches OptiMonk into the same shared list.
 *
 * Form contract:
 *   <form data-klaviyo-subscribe data-list-id="X6iyJY" data-source="Homepage newsletter">
 *     <div data-kl-row> <input type="email"> <button type="submit"> </div>
 *     <p data-kl-ok hidden>...</p>
 *     <p data-kl-err hidden>...</p>
 *   </form>
 */
(function () {
  'use strict';

  var REVISION = '2024-10-15';

  // Reuse the company_id from the Klaviyo Onsite <script> already in the page.
  function getCompanyId() {
    var scripts = document.querySelectorAll('script[src*="klaviyo.com/onsite/js/"]');
    for (var i = 0; i < scripts.length; i++) {
      var src = scripts[i].getAttribute('src') || '';
      var q = src.match(/[?&]company_id=([A-Za-z0-9]+)/);
      if (q) return q[1];
      var p = src.match(/\/onsite\/js\/([A-Za-z0-9]+)\//);
      if (p) return p[1];
    }
    if (window.klaviyo && typeof window.klaviyo.account === 'function') {
      try { var a = window.klaviyo.account(); if (a) return a; } catch (e) {}
    }
    return null;
  }

  function validEmail(v) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
  }

  function subscribe(companyId, listId, email, source) {
    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: source || 'Theme newsletter',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                subscriptions: {
                  email: { marketing: { consent: 'SUBSCRIBED' } }
                }
              }
            }
          }
        },
        relationships: {
          list: { data: { type: 'list', id: listId } }
        }
      }
    };
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: REVISION },
      body: JSON.stringify(payload)
    });
  }

  function initForm(form) {
    if (form.getAttribute('data-kl-init')) return;
    form.setAttribute('data-kl-init', '1');

    var listId = form.getAttribute('data-list-id');
    var source = form.getAttribute('data-source') || 'Theme newsletter';
    var input = form.querySelector('input[type="email"]');
    var btn = form.querySelector('button[type="submit"]');
    var row = form.querySelector('[data-kl-row]');
    var okEl = form.querySelector('[data-kl-ok]');
    var errEl = form.querySelector('[data-kl-err]');

    function showError(msg) {
      if (errEl) { errEl.hidden = false; if (msg) errEl.textContent = msg; }
      if (okEl) okEl.hidden = true;
    }
    function showSuccess() {
      if (okEl) okEl.hidden = false;
      if (errEl) errEl.hidden = true;
      if (row) row.hidden = true;
    }

    // Optionally ALSO create the native Shopify customer record (form_type=customer).
    // Best-effort, fire-and-forget, no redirect — the inline message is driven by
    // the Klaviyo result.
    function createShopifyCustomer() {
      try {
        fetch(form.getAttribute('action') || '/contact', {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'application/json' }
        }).catch(function () {});
      } catch (e) {}
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = input ? input.value.trim() : '';
      if (!validEmail(email)) { showError('Please enter a valid email address.'); return; }

      var companyId = getCompanyId();
      if (!companyId || !listId) { showError('Sorry — something went wrong. Please try again.'); return; }

      // Shopify customer record (if opted in) runs alongside the Klaviyo subscribe.
      if (form.hasAttribute('data-shopify-customer')) createShopifyCustomer();

      if (btn) btn.disabled = true;
      subscribe(companyId, listId, email, source)
        .then(function (r) {
          if (r.ok) {
            showSuccess();
          } else {
            if (btn) btn.disabled = false;
            showError('Sorry — that didn’t work. Please try again.');
          }
        })
        .catch(function () {
          if (btn) btn.disabled = false;
          showError('Sorry — that didn’t work. Please try again.');
        });
    });
  }

  function initAll() {
    var forms = document.querySelectorAll('[data-klaviyo-subscribe]');
    for (var i = 0; i < forms.length; i++) initForm(forms[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
